import {
  EXPERT_GRANTS_RESPONSE,
  EXPERT_GRANTS_FAILURE,
  EXPERT_GRANTS_MORE_REQUEST,
  EXPERT_GRANTS_MORE_FAILURE,
  EXPERT_GRANTS_MORE_RESPONSE,
  CLEAR_EXPERT_BIO_RESULTS,
  EXPERT_GRANTS_UPDATE
} from "../../actions/types";

const initialState = {
  isFetching: true,
  grants: [],
  error: false,
  from: 0,
  size: 10,
  isMoreResult: true,
  isMoreResultFetching: false,
  totalGrants: 0
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    grants: []
  };
};

const setResults = (state, action) => {
  let grants = action.payload.grants || [];
  let totalGrants = action.payload.totalGrants || 0;
  let isMoreResult = true;
  let size = state.size;
  if (grants.length < size) {
    isMoreResult = false;
  }

  return {
    ...state,
    isFetching: false,
    error: false,
    grants,
    isMoreResult,
    totalGrants
  };
};

const setMoreResultResponse = (state, action) => {
  let grants = action.payload.grants || [];
  let isMoreResult = true;

  if (grants.length == 0) {
    isMoreResult = false;
  }
  grants = [...state.grants, ...grants];

  return {
    ...state,
    grants,
    isMoreResult,
    isMoreResultFetching: false
  };
};

const setMoreResultRequest = (state, action) => {
  let from = action.payload.from || 0;
  return {
    ...state,
    isMoreResultFetching: true,
    from
  };
};

const setMoreResultFailure = (state, action) => {
  return {
    ...state,
    isMoreResultFetching: false
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EXPERT_GRANTS_RESPONSE:
      return setResults(state, action);
      break;

    case EXPERT_GRANTS_FAILURE:
      return setFailure(state, action);
      break;

    case EXPERT_GRANTS_MORE_REQUEST:
      return setMoreResultRequest(state, action);

    case EXPERT_GRANTS_MORE_FAILURE:
      return setMoreResultFailure(state, action);

    case EXPERT_GRANTS_MORE_RESPONSE:
      return setMoreResultResponse(state, action);

    case CLEAR_EXPERT_BIO_RESULTS:
      return initialState;

    case EXPERT_GRANTS_UPDATE:
      return setResults(state, action);

    default:
      return state;
      break;
  }
};
